import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import ServiceReferentiel from '../../services/ServiceReferentiel';
import { useCommandeContext, changeValeur } from "../../contexts/CommandeContext";

export default function CommuneAutocomplete({ id, required = false, disabled = false }) {

	// Initialisation de l'état par défaut
	const [commune, setCommune] = useState(undefined);

	// Récupération de la liste des communes desservies
	const communes = ServiceReferentiel.getCommunes();

	// Recupération de la commande et du dispatcher à partir du CommandeContext
	const { commande, dispatch } = useCommandeContext();

	useEffect(() => {
		setCommune(commande[id]);
	}, [commande, id]);

	function handleChange(key, value) {
		setCommune(value);
		dispatch(changeValeur(key, value));
	}

	let labelRequired = '';
	if (required)
		labelRequired = ' *';

	return (
		<Autocomplete
			required={required}
			disabled={disabled}
			disablePortal
			id={id}
			value={commune || null}
			options={communes}
			getOptionLabel={(option) => option.nomCommune + ' (' + option.codePostal + ')'}
			renderInput={(params) => <TextField {...params} label={'Commune / Code postal' + labelRequired} />}
			noOptionsText="Aucune correspondance"
			onChange={(_event, value) => { handleChange(id, value) }}
		/>
	);
}